module.exports = __webpack_public_path__ + "static/media/zurich.20c47bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/zurich.png
// module id = 121
// module chunks = 0